import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, CheckCircle } from 'lucide-react';
import { FaTiktok, FaTwitter, FaInstagram } from 'react-icons/fa';
import { subscribeNewsletter } from '../api/content';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    setMessage('');
    setError('');
    try {
      await subscribeNewsletter(email);
      setMessage('Subscribed successfully!');
      setEmail('');
    } catch (err) {
      setError(err.response?.data?.message || 'Subscription failed.');
    } finally {
      setLoading(false);
    }
  };
  return (
    <footer className="bg-white border-t border-gray-200 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-pink-500 to-red-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">R</span>
              </div>
              <span className="text-xl font-bold text-gray-900">Roar Homes</span>
            </div>
            <p className="text-gray-600 mb-4 max-w-md">
              Your premier destination for luxury short-term rentals. Experience exceptional stays in carefully curated properties around the world.
            </p>
            <div className="flex space-x-4">
              <a href="/" className="text-gray-400 hover:text-gray-600 transition-colors">
                <FaTiktok className="w-5 h-5" />
              </a>
              <a href="/" className="text-gray-400 hover:text-gray-600 transition-colors">
                <FaTwitter className="w-5 h-5" />
              </a>
              <a href="https://instagram.com/roar.ng" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-600 transition-colors">
                <FaInstagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-600 hover:text-gray-900 text-sm">About Us</Link></li>
              <li><Link to="/properties" className="text-gray-600 hover:text-gray-900 text-sm">Properties</Link></li>
              <li><Link to="/contact" className="text-gray-600 hover:text-gray-900 text-sm">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info & Newsletter */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Contact</h3>
            <div className="space-y-2 mb-6">
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-gray-400" />
                <span className="text-gray-600 text-sm">info@roar.ng</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-gray-400" />
                <span className="text-gray-600 text-sm">+2349137757000</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4 text-gray-400" />
                <span className="text-gray-600 text-sm">Lagos, NG</span>
              </div>
            </div>

            <h3 className="font-semibold text-gray-900 mb-4">Newsletter</h3>
            <form onSubmit={handleSubscribe} className="flex flex-col space-y-2">
              <input
                type="email"
                placeholder="Enter your email"
                className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-pink-500 text-sm"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button
                type="submit"
                disabled={loading}
                className="px-4 py-2 bg-gradient-to-r from-pink-500 to-red-500 text-white rounded-lg text-sm font-semibold hover:from-pink-600 hover:to-red-600 transition-colors disabled:opacity-50"
              >
                {loading ? 'Subscribing...' : 'Subscribe'}
              </button>
              {message && <p className="text-xs text-green-600 flex items-center"><CheckCircle className="w-3 h-3 mr-1"/>{message}</p>}
              {error && <p className="text-xs text-red-600">{error}</p>}
            </form>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <span className="text-sm text-gray-600">© 2026 Roar Homes LTD. All rights reserved.</span>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-sm text-gray-600 hover:text-gray-900">Privacy Policy</a>
              <Link to="/terms" className="text-sm text-gray-600 hover:text-gray-900">Terms of Service</Link>
              <a href="#" className="text-sm text-gray-600 hover:text-gray-900">Support</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
